import styled from "styled-components";

export const Svg = styled.svg`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
`;
